import React from "react";
import "./images.scss";

export const Logo = ({ url = "/" }) => {
  return (
    <figure>
      <a href={url}>
        <img
          src="https://s3.amazonaws.com/printwithme.com/images/v2_logos/pwm_logo_med.png"
          data-testid="logo-img"
        />
      </a>
    </figure>
  );
};

export const SmallLogo = ({ url = "/" }) => {
  return (
    <div className="theresa-small-logo">
      <Logo url={url} />
    </div>
  );
};
